import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { CheckCircle2 } from "lucide-react";
import { useIsMobile } from '@/hooks/use-mobile';
import { InsightItem } from '@/types/journey';
import InsightsContent from './insights/InsightsContent';

interface InsightsSectionProps {
  gaps: string;
  opportunities: string;
  insightItems: InsightItem[];
  onUpdate: (insights: { gaps: string; opportunities: string; insightItems?: InsightItem[] }) => void;
}

const InsightsSection: React.FC<InsightsSectionProps> = ({ 
  gaps, 
  opportunities, 
  insightItems = [],
  onUpdate 
}) => {
  const isComplete = !!(gaps && (opportunities || insightItems.length > 0));
  const isMobile = useIsMobile();
  
  // Handlers for updates
  const handleGapsChange = (newGaps: string) => {
    console.log('handleGapsChange:', newGaps);
    onUpdate({ gaps: newGaps, opportunities, insightItems });
  };
  
  const handleOpportunitiesChange = (newOpportunities: string) => {
    console.log('handleOpportunitiesChange:', newOpportunities);
    onUpdate({ gaps, opportunities: newOpportunities, insightItems });
  };

  const handleInsightUpdate = (newInsightItems: InsightItem[]) => {
    console.log('handleInsightUpdate:', newInsightItems);
    // Always pass the insightItems array, even if empty
    onUpdate({ 
      gaps, 
      opportunities, 
      insightItems: newInsightItems 
    });
  };

  return (
    <Card className="shadow-md relative h-full">
      <CardHeader className={`${isMobile ? 'py-1.5 px-3' : 'py-2 px-4'}`}>
        <CardTitle className={`${isMobile ? 'text-sm' : 'text-base'}`}>Key take away insights</CardTitle>
      </CardHeader>
      <CardContent className={`space-y-4 ${isMobile ? 'px-3 py-1.5' : 'px-4 py-2'}`}>
        <InsightsContent
          gaps={gaps}
          opportunities={opportunities}
          insightItems={insightItems || []}
          onGapsChange={handleGapsChange}
          onOpportunitiesChange={handleOpportunitiesChange}
          onInsightUpdate={handleInsightUpdate}
        />
      </CardContent>
      
      <CheckCircle2 
        className={`${isMobile ? 'h-3.5 w-3.5' : 'h-4 w-4'} absolute ${isMobile ? 'top-3 right-3' : 'top-4 right-4'} ${isComplete ? 'text-emerald-500' : 'text-gray-300'}`} 
        aria-label={isComplete ? "Insights complete" : "Insights incomplete"}
      />
    </Card>
  );
};

export default InsightsSection;
